module.exports = __webpack_public_path__ + "static/media/4b5f639c6868e92635ccee306b1ecd07.2633da7c.JPEG";